import React, { SVGAttributes } from 'react'

interface GiftProps extends SVGAttributes<SVGSVGElement> {
  mainColor?: string
  backgroundColor?: string
}

export const Gift: React.FC<GiftProps> = ({ mainColor = '#347DFE', backgroundColor = '#ACCDFF', ...props }) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      opacity="0.24"
      d="M20 2.3094C22.4752 0.880339 25.5248 0.880339 28 2.3094L40.7846 9.6906C43.2598 11.1197 44.7846 13.7607 44.7846 16.6188V31.3812C44.7846 34.2393 43.2598 36.8803 40.7846 38.3094L28 45.6906C25.5248 47.1197 22.4752 47.1197 20 45.6906L7.21539 38.3094C4.74018 36.8803 3.21539 34.2393 3.21539 31.3812V16.6188C3.21539 13.7607 4.74018 11.1197 7.21539 9.6906L20 2.3094Z"
      fill={backgroundColor}
    />
    <path
      d="M24 15C24 13.3431 25.3431 12 27 12C28.6569 12 30 13.3431 30 15C30 15.7684 29.7111 16.4692 29.2361 17H32.5C33.9045 17 34.6067 17 35.1111 17.3371C35.3295 17.483 35.517 17.6705 35.6629 17.8889C36 18.3933 36 19.0955 36 20.5C36 20.7057 36 20.8963 35.9989 21.0734C35.9958 21.5965 35.5662 22 35.0432 22L12.9568 22C12.4338 22 12.0042 21.5965 12.0011 21.0734C12 20.8963 12 20.7057 12 20.5C12 19.0955 12 18.3933 12.3371 17.8889C12.483 17.6705 12.6705 17.483 12.8889 17.3371C13.3933 17 14.0955 17 15.5 17H18.7639C18.2889 16.4692 18 15.7684 18 15C18 13.3431 19.3431 12 21 12C22.6569 12 24 13.3431 24 15Z"
      fill={mainColor}
    />
    <path
      d="M33.9984 25.0025C33.9998 24.45 33.5518 24 32.9993 24H26C25.4477 24 25 24.4477 25 25V34.9978C25 35.5507 25.4494 35.9995 26.0023 35.9952C29.3162 35.9694 31.2569 35.8057 32.3935 34.7642C33.8397 33.4391 33.984 30.6931 33.9984 25.0025Z"
      fill={mainColor}
    />
    <path
      d="M23 25C23 24.4477 22.5523 24 22 24H15.0007C14.4482 24 14.0002 24.45 14.0016 25.0025C14.016 30.6931 14.1603 33.4391 15.6065 34.7642C16.7431 35.8057 18.6838 35.9694 21.9977 35.9952C22.5506 35.9995 23 35.5507 23 34.9978V25Z"
      fill={mainColor}
    />
  </svg>
)
